
    <div *ngFor="let event of gifTicketEvents" class="mb-2">
        
        <div *ngIf="!event.notAvailable">
            <b>
                {{'FLEXIBLE_FIXED_BENEFITS.AVAILABLE_BETWEEN_DATES' | translate}}
                <b>
                    {{event.startDate | date:"dd.MM.yyyy"}}
                    -
                    {{event.endDate  | date:"dd.MM.yyyy"}}
                </b>
                {{'FLEXIBLE_FIXED_BENEFITS.FOR' | translate}}
            </b>
            <ul class="available-for-list pl-0">
                <li *ngFor="let item of event.giftTicketOrderableBy | orderableByGrouping ">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" checked disabled/>
                        <label class="custom-control-label">{{item.orderableBy | orderableByNiceName | translate }}</label>
                    </div>      
                </li>
            </ul>
        </div>

    </div>
